import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/due';

import Dues from './Dues';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.due,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Dues);
